import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/loader/forms.svg'
import _imports_1 from '@/assets/loader/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-dce1e5c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loader-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader-page__forms" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "loader-page__forms-image",
    src: _imports_0
  })
], -1))
const _hoisted_3 = { class: "loader-page__container" }
const _hoisted_4 = { class: "loader-page__container-box" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader-page__container-box__logo" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))
const _hoisted_6 = { class: "loader-page__container-box__name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.logoName), 1)
      ])
    ])
  ]))
}